import React from 'react';
import { Toast as RBToast } from 'react-bootstrap';
export default function Toast(_ref) {
  let {
    message,
    variant = 'success',
    show,
    onClose
  } = _ref;
  const textColor = variant === 'light' ? 'secondary' : 'white';
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'fixed',
      top: 0,
      right: 0,
      zIndex: 9999,
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(RBToast, {
    className: "bg-".concat(variant, " text-").concat(textColor),
    show: show,
    onClose: onClose,
    delay: 2000,
    autohide: true
  }, /*#__PURE__*/React.createElement(RBToast.Body, null, message)));
}